import { GroupedFieldsNoWrap } from "@components/smart/smartFastEntryList/SmartFastEntryList.styles";
import styled from "styled-components";

import { getDisabledStyle } from "../../global.style";
import TestIds from "../../testIds";
import { ButtonGroup } from "../button";
import Checkbox from "../inputs/checkbox";
import { CONNECTED_FIELD_MARGIN, FIELD_HEIGHT, StyledField } from "../inputs/field/Field.styles";
import FieldsWrapper from "../inputs/field/FieldsWrapper";

export const REORDER_ICON_MARGIN = 5;

interface IHasLabel {
    fieldHasLabel?: boolean;
}

export const StyledFastEntry = styled.div`
    position: relative;
    display: flex;
`;

export const LineWrapper = styled(FieldsWrapper)<IHasLabel & {
    _hideContent?: boolean;
}>`
    position: relative;
    
    ${props => props._hideContent && `
    & > div:not([data-testid=${TestIds.ComparisonBorder}]):not([data-testid=${TestIds.AuditTrailLineOrder}]) {
      opacity: 0;
    }
    `}
`;

export const LineWrapperComparisonBorder = styled.div`
    position: absolute;
    top: -10px;
    left: -10px;
    width: calc(100% + 21px);
    height: calc(100% + 14px);
    border: 3px dashed ${props => props.theme.C_AUDIT_TRAIL_DIFF};
    border-radius: ${props => props.theme.borderLargeRadius};
    z-index: 180;
`;

export const LineOrder = styled.div <{
    $isChangedOrder: boolean;
}>`
    color: ${props => props.$isChangedOrder ? props.theme.C_AUDIT_TRAIL_DIFF : "#dadada"};
    font-weight: bold;
    position: absolute;
    font-size: 13px;
    top: 27px;
    left: -19px;
`;

export const LastFieldWrapper = styled.div`
    display: flex;
    align-items: flex-end;

    ${GroupedFieldsNoWrap} > ${StyledField} {
        margin-right: ${CONNECTED_FIELD_MARGIN};
    }
    
    ${StyledField}, ${GroupedFieldsNoWrap} > ${StyledField}:last-child {
        margin-right: 0;
    }
`;

export const IconWrapper = styled.div<IHasLabel & { $isDisabled?: boolean }>`
    position: relative;
    flex-shrink: 0;
    cursor: pointer;
    top: 5px;
    margin-bottom: 5px;
    margin-right: ${REORDER_ICON_MARGIN}px;
    height: fit-content;

    ${props => props.fieldHasLabel && `
        top: 23px;
        margin-bottom: 23px
    `}
    
    ${props => getDisabledStyle(props.$isDisabled)}
`;

export const RightIconButtonGroup = styled(ButtonGroup)<IHasLabel>`
    display: flex;
    position: relative;
    margin-left: 5px;
    height: ${FIELD_HEIGHT};
    gap: 2px
    .extra-action-button {
        margin-right: 3px;
    }
`;

export const CheckboxStyledFastEntry = styled(Checkbox)<{
    fieldHasLabel: boolean;
    isDisabled: boolean;
}>`
    align-self: flex-start;
    margin-right: 12px;
    margin-left: 8px;
    top: ${props => props.fieldHasLabel ? "26px" : "10px"};
    opacity: ${props => props.isDisabled ? 0 : 1};
`;